import { createSlice, type PayloadAction } from '@reduxjs/toolkit'
// Removed unused imports to satisfy ESLint

export interface FilterKeyDeviceMappings {
  type: string[]
}

export interface getFilterTypesForDeviceKeyMappingsState {
  isLoading: boolean
  // Always store the raw array of key type strings
  data: string[] | null
  error: string | null
  httpStatus: number | null
}

const initialState: getFilterTypesForDeviceKeyMappingsState = {
  isLoading: false,
  data: null,
  error: null,
  httpStatus: 0
}

export const getFilterTypesForDeviceKeyMappingsSlice = createSlice({
  name: 'FilterTypesForDeviceKeyMappings',
  initialState,
  reducers: {
    getFilterTypesForDeviceKeyMappingsLoading: (state): getFilterTypesForDeviceKeyMappingsState => ({
      isLoading: true,
      data: [],
      error: null,
      httpStatus: 0
    }),
    getFilterTypesForDeviceKeyMappingsError: (state, action: PayloadAction<{ errorMessage: string, httpStatus: number }>): getFilterTypesForDeviceKeyMappingsState => ({
      isLoading: false,
      data: null,
      error: action.payload.errorMessage,
      httpStatus: action.payload.httpStatus
    }),
    getFilterTypesForDeviceKeyMappingsData: (state, action: PayloadAction<any>): getFilterTypesForDeviceKeyMappingsState => {
      // Accept several shapes: raw array, service response object, or object with nested data/type
      const payload = action.payload.data
      let arr: string[] | null = null
      if (Array.isArray(payload)) {
        arr = payload
      } else if (Array.isArray(payload?.data)) {
        arr = payload.data
      } else if (Array.isArray(payload?.type)) {
        arr = payload.type
      }
      return {
        isLoading: false,
        data: arr,
        error: null,
        httpStatus: action.payload.httpStatus
      }
    }
  }
})

export const { getFilterTypesForDeviceKeyMappingsLoading, getFilterTypesForDeviceKeyMappingsError, getFilterTypesForDeviceKeyMappingsData } = getFilterTypesForDeviceKeyMappingsSlice.actions
export default getFilterTypesForDeviceKeyMappingsSlice.reducer
